/**
 * Wrap window.location so that it's testable.
 */

const getLocation = () => {
	if (typeof window !== 'undefined') {
		return window.location;
	}
	return undefined;
};

export default getLocation;
